<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="frontmatter">
<section epub:type="division">
<p class="C333" id="page_ix">
<strong>ACKNOWLEDGEMENTS</strong>
</p>
<p class="C340">I would like to thank the members of the Editorial Board – Michael Black, Jim Boulton, Lindeth Vasey and John Worthen – for their invaluable help on editorial matters and the following for their particular contributions: Anne Caesar, Manuela Camerino, George Donaldson, David Dunkerley, Gabrielle Firmager and Patrick Keeley. I must also thank Columbia University, Yale University and the Harry Ransom Humanities Research Center, University of Texas at Austin, for making available the materials in their collections, and the Leverhulme Trust for awarding me a grant to undertake the work initially.</p>
<div class="table">
<table class="C393" style="width:100%;">
<tr class="T342_Row">
<td class="C394" style="vertical-align:top;">
<em>October 1996</em>
</td>
<td class="C395" style="vertical-align:top;">
<p class="jus-r">M. K.</p>
</td>
</tr>
</table>
</div>
</section>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Acknowledgements.vue?f9ce3e12